import React, { useContext, useMemo } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ReactApexChart from "react-apexcharts";
import { useTranslation } from 'react-i18next';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
//import { useEffect } from 'react';
//import { useRef } from 'react';
import { useBoolean } from '@fluentui/react-hooks';
import { Callout, FontWeights, SpinnerSize, Text, TooltipHost, mergeStyleSets } from '@fluentui/react';
import ChartGauge from '../Chart/ChartGauge';
import { useState } from 'react';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';
import { useSetInicialValues } from '../../../../../../hooks/component/sKPI/useOfOCRChart';
import MainAppContext from '../../../../../../MainAppContext';
import Loading from "../../../../../Templates/Site/Loading";

function OCR_CHART(props) {
	const { t } = useTranslation();
	const contextSite = useContext(MainAppContext);

	const { _boardVariableDataserieValues: boardVariableDataserieValues } = useSelector((state) => state.boardViewScope);

	const { 
		inputParam_BoardId = null,
		inputParam_ElementId = null,
		inputParam_ReportMode = false,
		inputParam_HideHeader = false,
		inputParam_ComponentContent = null,
		inputParam_ShowGauge = false,
		inputParam_ReportHeaderMode = false,
		inputParam_BoardStructure = null,
		inputParam_Container = null,
		inputParam_ContextualChart = true
	} = props;

	
	const { _listComponentTypeConfig: listComponentTypeConfig } = useSelector((state) => state.boardViewScope);

	const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
	const [selectedGaugeDataPointIndex, setSelectedGaugeDataPointIndex] = useState(null);

	const [chartDataConfig, setChartDataConfig] = useState({
		listSeriesX: null,
		listSerieTimeY: null,
		_baseSerieNames: null,
	});
	
	const [lastGaugeDataPointIndex, setLastGaugeDataPointIndex] = useState();
	
	const acronim_titles = {
		acronim_s1_real: { acronim: "S1-Real", text: t("data-lang-lbl-field-valueReal")},
		acronim_s1_valueGoal: {acronim: "S1-Goal", text: t("data-lang-lbl-field-valueGoal")},
		acronim_s1_valueGoalPercent: {acronim: "S1-GoalP", text: t("data-lang-lbl-field-valueGoalPercent")},
	}

	useSetInicialValues(
		inputParam_BoardId,
		inputParam_ElementId,
		listComponentTypeConfig,
		contextSite.kpiModule.boardCalendarFilterConfig,
		false,
		inputParam_ComponentContent,
		inputParam_ContextualChart,
		chartDataConfig,
		setChartDataConfig,
		acronim_titles,
		inputParam_ReportMode
	);

	const getTitleSubTitle = () => {

		let title = '';
		let subtitle = '';

		
		if (boardVariableDataserieValues !== null && inputParam_ComponentContent !== null) {
			if ( (inputParam_ComponentContent.items !== null && inputParam_ComponentContent.items.length > 0) && inputParam_ComponentContent.items[0].l_dataserie !== undefined && inputParam_ComponentContent.items[0].l_dataserie.length > 0) {
				const item = boardVariableDataserieValues.find(x => x.dataserieId === (inputParam_ComponentContent.items[0].l_dataserie[0].newDataSerieId));
				title = !isNullUndefinedOrEmpty(item) ? item.variableName : "";
				subtitle = !isNullUndefinedOrEmpty(item) ? item.um : "";
			}
			if (inputParam_ComponentContent.items !== null && inputParam_ComponentContent.items.l_dataserie !== undefined && inputParam_ComponentContent.items.l_dataserie.length > 0) {
				const item = boardVariableDataserieValues.find(x => x.dataserieId === (inputParam_ComponentContent.items.l_dataserie[0].newDataSerieId))
				title = !isNullUndefinedOrEmpty(item) ? item.variableName : "";
				subtitle = !isNullUndefinedOrEmpty(item) ? item.um : "";
			}
		}

		return { title: title, subtitle: subtitle }
	}

	const objTitles = getTitleSubTitle()

	const aux_title = inputParam_ComponentContent && inputParam_ComponentContent.items.length > 0 ?
							(inputParam_ComponentContent.items[0].l_dataserie !== undefined ?
								(inputParam_ComponentContent.items[0].l_dataserie.length > 0 ?
									inputParam_ComponentContent.items[0].l_dataserie[0].variableName : ""
								) : ""
							): "";

	const styles = mergeStyleSets({
		callout: {
			width: 320,
			maxWidth: '90%',
			padding: '20px 24px',
		},
		title: {
			marginBottom: 12,
			fontWeight: FontWeights.semilight,
		}
	});

	const checkDataPointIndex = () => {
		const currentDataPointIndexLength = (inputParam_ComponentContent ? (inputParam_ComponentContent.items.length > 0 ?
				(inputParam_ComponentContent.items[0].l_vals !== undefined ? inputParam_ComponentContent.items[0].l_vals.length - 1 : (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.length -1 : 0) : 0))
			: 0): 0)

		if (currentDataPointIndexLength !== lastGaugeDataPointIndex) {
			setSelectedGaugeDataPointIndex(currentDataPointIndexLength)
			setLastGaugeDataPointIndex(currentDataPointIndexLength)
		}
		
		return currentDataPointIndexLength
	}

	const categories = chartDataConfig.listSerieTimeY;
	const series = chartDataConfig.listSeriesX;

	const columnSeriesIdx = useMemo(
		() =>
		series ?
		series
			.map((s, i) => (s.type === "column" ? i : null))
			.filter((i) => i !== null) : [],
		[series]
	);

  	const dashArray = (series ?? []).map(s => {
		if (s.type === "column") return 0;
		if (s.name === acronim_titles.acronim_s1_valueGoalPercent.acronim) return 6;
		return 0;
	});

  	const options = useMemo(() => {
		return {
			chart: {
				type: "line",
				stacked: false,
				height: 350,
				toolbar: { show: true },
				events: {
					dataPointSelection: (event, chartContext, config) => { 
						setTimeout(() => {
							//dispatch(action_setBoardChartGaugeSelectedDataPoint(config.dataPointIndex))
							setSelectedGaugeDataPointIndex(config.dataPointIndex);
						}, 10);
					}
				},
			},
			colors: ['#1F7BE8', '#FF8000', '#000099'],
			xaxis: {
				categories,
				labels: { rotate: -45, style: { fontSize: "11px" } },
			},

			plotOptions: {
				bar: {
				dataLabels: { position: "top" },
				columnWidth: "45%",
				},
			},
			dataLabels: {
				enabled: true,
				enabledOnSeries: columnSeriesIdx,
				offsetY: -10,
				formatter: (val) => {
					if (val === null || val === undefined || val === "") return ""; // sin dato
					const n = Number(val);
					if (!Number.isFinite(n)) return ""; // sin dato
					return n === 0 ? "0" : "";          // SOLO mostrar cuando es 0
				},
				style: {
					colors: ["#000"],
					fontSize: "12px",
					fontWeight: 600,
				},
				background: {
					enabled: false,
				},
				dropShadow: {
					enabled: false,
				},
			},

			stroke: {
				width: series ? series.map((s) => (s.type === "column" ? 0 : 2)) : 2,
				dashArray,
				curve: "straight",
			},
			markers: {
				size: series ? series.map((s) => (s.type === "column" ? 0 : 4)) : 4,
			},

			yaxis: chartDataConfig._baseSerieNames,

			tooltip: {
				shared: true,
				intersect: false,
			},

			legend: {
				horizontalAlign: "center",
			},
		};
	}, [categories, series, columnSeriesIdx]);

	return  <Card className='board-element-form h-100'>
		{
			!inputParam_HideHeader &&
			<>
				{
					inputParam_ReportHeaderMode ?
					<Card.Body className='p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
						<TooltipHost content={inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}>
							<div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
								{
									!isNullUndefinedOrEmpty(aux_title) &&
									<b>{t('data-lang-lbl-selectedkpi')}: {aux_title}</b>
								}
								{
									isNullUndefinedOrEmpty(aux_title) &&
									<b>{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}</b>
								}
							</div>
						</TooltipHost>
					</Card.Body> :
					<Card.Header className="card-header-compact">
						<Card.Title className="d-flex justify-content-between">
								{
									!isNullUndefinedOrEmpty(aux_title) &&
									<>
									{
										listComponentTypeConfig.dataserieId === null &&
										<>
										{
											listComponentTypeConfig.forceOCRLoad === false && chartDataConfig.listSeriesX && chartDataConfig.listSerieTimeY && chartDataConfig._baseSerieNames ?
											<b>{t('data-lang-lbl-selectedkpi')}: {aux_title}</b> :
											<b>{t('data-lang-lbl-chart')}</b>
										}
										</>
									}
									{
										listComponentTypeConfig.dataserieId !== null &&
										<>
										{
											listComponentTypeConfig.forceOCRLoad === false && chartDataConfig.listSeriesX && chartDataConfig.listSerieTimeY && chartDataConfig._baseSerieNames ?
											<b>{t('data-lang-lbl-selectedkpi')}: {aux_title}</b> :
											<b>{t('data-lang-lbl-selectedkpi')}: {t('data-lang-lbl-loading')}</b>
										}
										</>
									}
									</>
								}
								{
									isNullUndefinedOrEmpty(aux_title) &&
									<b>{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}</b>
								}
							<div className='toolbar d-flex'>
								<HEADER_TOOLBAR
									inputParam_BoardStructure={inputParam_BoardStructure}
									inputParam_Container={inputParam_Container}
								/>
							</div>
						</Card.Title>
					</Card.Header>
				}
			</>
		}
		{
			listComponentTypeConfig.dataserieId !== null &&
			<>
				{
					listComponentTypeConfig.forceOCRLoad === false && 
					<>
					{
						chartDataConfig.listSeriesX && chartDataConfig.listSerieTimeY && chartDataConfig._baseSerieNames ?
						<>
							<Card.Body className='h-100 px-2 pt-2'>
							{
								inputParam_ComponentContent ?
									<div className='px-3 h-100 d-flex'>
										{
											inputParam_ShowGauge && (checkDataPointIndex() === lastGaugeDataPointIndex) &&
												<ChartGauge
													inputParam_ComponentContent={inputParam_ComponentContent.items[0]}
													selectedGaugeDataPointIndex={selectedGaugeDataPointIndex}
												/>
										}
										<Col>
											<ReactApexChart options={options} series={series} type="line" height={"100%"} />
											{isCalloutVisible &&
												<Callout
													role="dialog"
													gapSpace={0}
													target={`.custom-legeng-chart`}
													onDismiss={toggleIsCalloutVisible}
													setInitialFocus
													className={styles.callout}
												>
													<Text as="h1" block variant="xLarge"> { t('data-lang-lbl-chartlegend') } </Text>
													<Text className='pb-2' block variant="small">
														<Row>
															<Col className='col-auto'>
																<b>{`${acronim_titles.acronim_s1_real.acronim}:`}</b> {`${acronim_titles.acronim_s1_real.text}`}
															</Col>
														</Row>
														<Row>
															<Col className='col-auto'>
																<b>{`${acronim_titles.acronim_s1_valueGoal.acronim}:`}</b> {`${acronim_titles.acronim_s1_valueGoal.text}`}
															</Col>
														</Row>
														<Row>
															<Col className='col-auto'>
																<b>{`${acronim_titles.acronim_s1_valueGoalPercent.acronim}:`}</b> {`${acronim_titles.acronim_s1_valueGoalPercent.text}`}
															</Col>
														</Row>
													</Text>
												</Callout>
											}
										</Col>
									</div>
									: <NoDataLayer display={ true } />
								}
							</Card.Body>
						</> : <NoDataLayer text={t('data-lang-msg-selectdataserie')} display={ true } className={ "col-auto my-auto h-100" } />
					}
					</>
				}
				{
					listComponentTypeConfig.forceOCRLoad === true && 
					<div>
						<Loading
							inputParam_Style={{marginTop: 80}}
							inputParam_ShowLoading={true}
							inputParam_SpinnerSize={SpinnerSize.small}
							inputParam_Width={'25px'}
							inputParam_Height={'25px'}
							inputParam_MarginLeft={"8px"}
						/>
					</div>
					
				}
			</>
		}
		{
			listComponentTypeConfig.dataserieId === null &&
			<>
				<NoDataLayer text={t('data-lang-msg-selectdataserie')} display={ true } className={ "col-auto my-auto" } />
			</>
		}
	</Card>
}
OCR_CHART.propTypes = {
	inputParam_Height: PropTypes.number,
	inputParam_ReportMode: PropTypes.bool,
};
export default OCR_CHART;